<label class="field__label">{{label}}</label>
<p class="field__label--sublabel">{{selectedValues.length}} selected</p>
<select
    multiple
    (change)="updateSelection($event.target.options)"
    (blur)="onBlur()"
    class="field__input field__input--multiselect"
    [ngClass]="{'field__input--error': errorMessages.length}"
    [disabled]="disabled"
>
    <option *ngFor="let option of options" value="{{option.value}}" [selected]="isSelected(option)">
        {{option.text}}
    </option>
</select>
<ErrorMessages [errorMessages]="errorMessages"></ErrorMessages>
